import { MatchesClient, MatchTableLinksVm } from '../../../utils/api';

// Tokens stay in memory, shared by the report and Table links panel in this tab.
const cache = new Map<number, Promise<MatchTableLinksVm>>();
export async function getTableLinks(matchId: number): Promise<MatchTableLinksVm> {
    const pending = cache.get(matchId);
    if (pending) {
        const value = await pending;
        if (Date.parse(value.validUntil || '') > Date.now()) return value;
        if (cache.get(matchId) === pending) cache.delete(matchId);
    }
    // A concurrent caller may have started renewal while we awaited the cache.
    const renewing = cache.get(matchId);
    if (renewing) return renewing;
    const request = new MatchesClient().getTableLinks(matchId);
    cache.set(matchId, request);
    try {
        const result = await request;
        if (result.status !== 'ok') cache.delete(matchId);
        return result;
    } catch (error) {
        cache.delete(matchId);
        throw error;
    }
}
